export enum PaymentProvider {
  SOFTPAY = "SOFTPAY",
  WESTPAY = "WESTPAY",
  MARKETPAY = "MARKETPAY",
  VIVA = "VIVA",
  NETS = "NETS",
}
